import { ApiProcess } from "@api/apiProcesses";
import { FeatureFlag } from "@core/feature-flags/feature-flag.model";
import { Navigation } from "@core/navigation/navigation.model";
import { FormControlConfig } from "@shared/components/form/form-control/form-control.model";
import { Observable } from "rxjs";
import { Schema } from "type-fest";

export const userVisibleProcesses:ApiProcess[] = [
    ApiProcess.AssetRegisterBulkUploadProcessJob,
    ApiProcess.AssetRegisterDepreciationScheduleProcessJob,
    ApiProcess.AssetRegisterReportAdditionsDisposalJob,
    ApiProcess.AssetRegisterReportAssetJob,
    ApiProcess.AssetRegisterReportDepreciationJob,
    ApiProcess.AssetRegisterReportMovementJob,
    ApiProcess.AssetRegisterReportValuationJob,
    ApiProcess.AssetRegisterReportAuditVerificationJob,
]

export interface ProcessGroup {
    code: Navigation,
    name: string,
    processes: ProcessItem[],
    access?: FeatureFlag
}

export interface ProcessItem<T = any> {
    code: string,
    name: string,
    process: (data?:T) => Observable<any>,
    access?: FeatureFlag 
}

export interface ReportGroup extends Omit<ProcessGroup, 'processes'>{
    reports: ReportItem[]
}

export interface ReportItem<T = any> extends Omit<ProcessItem<T>, 'process'>{
    report: (data?:T) => Observable<any>,
    body: Schema<T, FormControlConfig, {recurseIntoArrays:false}>
}